import React, { useState, useEffect, useMemo } from 'react'
import { X } from 'lucide-react';
import delete_icon from "../../assets/svg/combined_charges_delete.svg";
import edit_icon from "../../assets/svg/combined_charges_edit.svg";
import expanded_icon from "../../assets/svg/expanded_icon.svg";
import axiosInstance from "../../axiosInstance";
import { ToastContainer, toast } from "react-toastify"
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../styles/MergedCharges.css"
import GenerateSeparatePopup from './GenerateSeparateInvoice';
import { useNavigate } from 'react-router-dom';
import SapCsvSafeInput from '../../CommonRemarksRestriction/SapCsvSafeInput';

const MergedCharges = ({ isOpen, onClose, mergedChargesData, allCategories, projectId, selectedChargeIds, backdatedDays = 0 }) => {

    const [groupedData, setGroupedData] = useState([]);
    const [combinedCharges, setCombinedCharges] = useState([]);
    const [isCombining, setIsCombining] = useState(false);
    const [selectedCombinedIds, setSelectedCombinedIds] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);
    const [openRevertPopup, setOpenRevertPopup] = useState(false);
    const [chargeToRevertId, setChargeToRevertId] = useState(null);

    const [isGenerateSeparatePopupOpen, setIsGenerateSeparatePopupOpen] = useState(false);
    const [separateChargesData, setSeparateChargesData] = useState([]);
    const [isLoadingSeparateCharges, setIsLoadingSeparateCharges] = useState(false);

    const [openSaveDialog, setOpenSaveDialog] = useState(false);
    const [openSubmitDialog, setOpenSubmitDialog] = useState(false);

    const [submitting, setSubmitting] = useState(false);
    const [billingNature, setBillingNature] = useState("");
    const [supplyPeriod, setSupplyPeriod] = useState(null);
    const [backdatedDate, setBackdatedDate] = useState(null);
    const [salesHeaderRemarks, setSalesHeaderRemarks] = useState("");
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [openSeparateConfirmDialog, setOpenSeparateConfirmDialog] = useState(false);
    const [submitErrors, setSubmitErrors] = useState({
        remarks: "",
        billingNature: "",
        supplyPeriod: "",
        backdatedDate: ""
    });
    const navigate = useNavigate();


    useEffect(() => {
        console.log("🔵 mergedChargesData received:", mergedChargesData);

        if (mergedChargesData && mergedChargesData.length > 0) {
            const groupedMap = {};
            console.log("🟡 Initial groupedMap:", groupedMap);

            mergedChargesData.forEach((group, groupIndex) => {
                console.log(`\n==============================`);
                console.log(`👉 PROCESSING GROUP #${groupIndex}`, group);

                const sapKey = group.sap_id;
                console.log("SAP KEY:", sapKey);

                if (!groupedMap[sapKey]) {
                    groupedMap[sapKey] = {
                        sap_id: sapKey,
                        sap_code: group.sap_code,
                        sap_description: group.sap_description,
                        job_ids: [...(group.job_ids || [])],
                        charge_ids: [...(group.charge_ids || [])],
                        rows: [],
                        total_quantity: 0,
                        total_net_total: 0,
                        total_accrual: 0
                    };

                    console.log(`🟢 Created new group in groupedMap for SAP: ${sapKey}`, groupedMap[sapKey]);
                }

                group.rows.forEach((row, rowIndex) => {
                    const newRow = {
                        ...row,
                        isCombined: false,
                        isChecked: false,
                        uniqueId: `${row.job_line_id}_${row.sap_id}_${row.job_id}`
                    };

                    console.log(`   ➕ Adding row #${rowIndex} to SAP ${sapKey}`, newRow);
                    groupedMap[sapKey].rows.push(newRow);
                });
            });

            console.log("\n🔵 groupedMap after row insert:", groupedMap);

            Object.keys(groupedMap).forEach(sapKey => {
                const currentGroup = groupedMap[sapKey];

                console.log(`\n📌 Calculating totals for SAP ${sapKey}`);

                currentGroup.total_quantity = currentGroup.rows
                    .filter(row => !row.isCombined)
                    .reduce((sum, row) => sum + (parseFloat(row.unit_of_quantity) || 0), 0);

                currentGroup.total_net_total = currentGroup.rows
                    .filter(row => !row.isCombined)
                    .reduce((sum, row) => sum + (parseFloat(row.net_total) || 0), 0);

                currentGroup.total_accrual = currentGroup.rows
                    .filter(row => !row.isCombined)
                    .reduce((sum, row) => sum + (parseFloat(row.accrual) || 0), 0);

                console.log(`   ✔ total_quantity: ${currentGroup.total_quantity}`);
                console.log(`   ✔ total_net_total: ${currentGroup.total_net_total}`);
                console.log(`   ✔ total_accrual: ${currentGroup.total_accrual}`);
            });

            const firstRow = mergedChargesData[0]?.rows?.[0];
            if (firstRow?.supply_period) {
                const [month, year] = firstRow.supply_period.split("-");
                const date = new Date(`${month} 1, ${year}`);
                setSupplyPeriod(date);
            }

            const groupedArray = Object.values(groupedMap);

            console.log("\n✅ Final groupedArray:", groupedArray);

            setGroupedData(groupedArray);
        }
    }, [mergedChargesData]);

    const getSelectedRows = () => {
        const selectedRows = [];
        groupedData.forEach(group => {
            group.rows.forEach(row => {
                if (row.isChecked && !row.isCombined) {
                    selectedRows.push({
                        job_line_id: row.job_line_id,
                        sap_id: group.sap_id,
                        rowData: row
                    });
                }
            });
        });
        return selectedRows;
    };

    const getGroupSelectedRows = (group) => {
        return group.rows.filter(row => row.isChecked && !row.isCombined);
    };

    const handleRowCheckboxChange = (rowId, groupSapId) => {
        setGroupedData(prev => prev.map(group => {
            if (group.sap_id === groupSapId) {
                return {
                    ...group,
                    rows: group.rows.map(row => {
                        if (row.uniqueId === rowId) {
                            return { ...row, isChecked: !row.isChecked };
                        }
                        return row;
                    })
                };
            }
            return group;
        }));
    };

    const handleGroupCheckboxChange = (groupSapId) => {
        setGroupedData(prev => prev.map(group => {
            if (group.sap_id === groupSapId) {
                // Get all uncombined rows
                const uncombinedRows = group.rows.filter(row => !row.isCombined);
                const allChecked = uncombinedRows.length > 0 &&
                    uncombinedRows.every(row => row.isChecked);
                const shouldCheck = !allChecked;

                return {
                    ...group,
                    rows: group.rows.map(row => {
                        if (!row.isCombined) {
                            return { ...row, isChecked: shouldCheck };
                        }
                        return row;
                    })
                };
            }
            return group;
        }));
    };

    const handleCombine = async () => {
        try {
            setIsCombining(true);
            const selectedBySap = {};
            const selectedRowIds = new Set();

            groupedData.forEach(group => {
                group.rows.forEach(row => {
                    if (row.isChecked && !row.isCombined) {
                        if (!selectedBySap[group.sap_id]) {
                            selectedBySap[group.sap_id] = {
                                sap_id: group.sap_id,
                                sap_code: group.sap_code,
                                sap_description: group.sap_description,
                                job_line_ids: [],
                                original_rows: []
                            };
                        }
                        selectedBySap[group.sap_id].job_line_ids.push(row.job_line_id);
                        selectedBySap[group.sap_id].original_rows.push(row);
                        selectedRowIds.add(row.uniqueId);
                    }
                });
            });

            const combinePayload = Object.values(selectedBySap);

            if (combinePayload.length === 0) {
                toast.warning("Please select at least one item to combine");
                return;
            }

            const response = await axiosInstance.post('/invoice/combinecharges', {
                combined_data: combinePayload
            });

            if (response.data.success) {
                setCombinedCharges(prev => {
                    const updated = [...prev];

                    response.data.data.forEach((newItem, index) => {
                        const payloadItem = combinePayload.find(p => p.sap_id === newItem.sap_id);
                        updated.push({
                            ...newItem,
                            charge_code:
                                newItem.charge_code ||
                                payloadItem?.original_rows?.[0]?.charge_code ||
                                "",
                            combinedId: `combined_${newItem.sap_id}_${Date.now()}_${index}`,
                            job_line_ids_string: newItem.job_line_ids.join(", "),
                            original_rows: payloadItem?.original_rows || []
                        });
                    });

                    return updated;
                });

                setGroupedData(prev => prev.map(group => {
                    const payloadForGroup = combinePayload.find(p => p.sap_id === group.sap_id);
                    if (payloadForGroup) {
                        return {
                            ...group,
                            rows: group.rows.map(row => {
                                if (payloadForGroup.job_line_ids.includes(row.job_line_id)) {
                                    return {
                                        ...row,
                                        isCombined: true,
                                        isChecked: false
                                    };
                                }
                                return row;
                            }),
                            total_quantity: group.rows
                                .filter(row => !row.isCombined && !payloadForGroup.job_line_ids.includes(row.job_line_id))
                                .reduce((sum, row) => sum + (parseFloat(row.unit_of_quantity) || 0), 0),
                            total_net_total: group.rows
                                .filter(row => !row.isCombined && !payloadForGroup.job_line_ids.includes(row.job_line_id))
                                .reduce((sum, row) => sum + (parseFloat(row.net_total) || 0), 0),
                            total_accrual: group.rows
                                .filter(row => !row.isCombined && !payloadForGroup.job_line_ids.includes(row.job_line_id))
                                .reduce((sum, row) => sum + (parseFloat(row.accrual) || 0), 0)
                        };
                    }
                    return group;
                }));

                toast.success("Charges combined successfully");
            } else {
                toast.error("Failed to combine charges");
            }
        } catch (error) {
            console.error("Error combining charges:", error);
            toast.error("Error combining charges");
        } finally {
            setIsCombining(false);
        }
    };

    const handleRevert = async (combinedId) => {
        try {
            const combinedItem = combinedCharges.find(item => item.combinedId === combinedId);

            if (!combinedItem) {
                toast.error("No charge found to revert");
                return;
            }

            const revertPayload = [{
                sap_id: combinedItem.sap_id,
                job_line_ids: combinedItem.job_line_ids
            }];

            const response = await axiosInstance.post('/invoice/revertcharges', {
                revert_data: revertPayload
            });

            if (response.data.success) {
                setCombinedCharges(prev => prev.filter(item => item.combinedId !== combinedId));

                setSelectedCombinedIds(prev => prev.filter(id => id !== combinedId));

                const revertedRows = response.data.data.flatMap(group =>
                    group.rows.map(row => {
                        const originalRow =
                            combinedItem.original_rows.find(r => r.job_line_id === row.job_line_id);

                        return {
                            ...row,
                            plant_code: row.plant_code ?? originalRow?.plant_code ?? "",
                            project_code: row.project_code ?? originalRow?.project_code ?? "",
                            sap_code: row.sap_code ?? originalRow?.sap_code ?? "",
                            description: row.description ?? originalRow?.description ?? "",
                            isCombined: false,
                            isChecked: false,
                            uniqueId: `${row.job_line_id}_${row.sap_id}_${row.job_id}`
                        };
                    })
                );


                setGroupedData(prev => {
                    const updated = [...prev];

                    revertedRows.forEach(revertedRow => {
                        const existingGroup = updated.find(g => g.sap_id === revertedRow.sap_id);

                        if (existingGroup) {
                            const existingRowIndex = existingGroup.rows.findIndex(
                                r => r.job_line_id === revertedRow.job_line_id
                            );

                            if (existingRowIndex >= 0) {
                                updated[updated.indexOf(existingGroup)].rows[existingRowIndex] = revertedRow;
                            } else {
                                updated[updated.indexOf(existingGroup)].rows.push(revertedRow);
                            }
                        } else {
                            updated.push({
                                sap_id: revertedRow.sap_id,
                                sap_code: revertedRow.sap_code,
                                sap_description: revertedRow.sap_description,
                                job_ids: [revertedRow.job_id],
                                charge_ids: [revertedRow.charge_id],
                                rows: [revertedRow],
                                total_quantity: revertedRow.unit_of_quantity,
                                total_net_total: revertedRow.net_total,
                                total_accrual: revertedRow.accrual
                            });
                        }
                    });

                    return updated.map(group => ({
                        ...group,
                        total_quantity: group.rows
                            .filter(row => !row.isCombined)
                            .reduce((sum, row) => sum + (parseFloat(row.unit_of_quantity) || 0), 0),
                        total_net_total: group.rows
                            .filter(row => !row.isCombined)
                            .reduce((sum, row) => sum + (parseFloat(row.net_total) || 0), 0),
                        total_accrual: group.rows
                            .filter(row => !row.isCombined)
                            .reduce((sum, row) => sum + (parseFloat(row.accrual) || 0), 0)
                    }));
                });

                toast.success("Combined charge reverted successfully");
            } else {
                toast.error("Failed to revert charge");
            }
        } catch (error) {
            console.error("Error reverting charge:", error);
            toast.error("Error reverting charge");
        }
    };

    const handleRevertSingle = async (combinedId, jobLineId) => {
        try {
            const combinedItem = combinedCharges.find(item => item.combinedId === combinedId);
            if (!combinedItem) {
                toast.error("Combined charge not found");
                return;
            }

            const rowToRevert = combinedItem.original_rows?.find(row => row.job_line_id === jobLineId);
            if (!rowToRevert) {
                toast.error("Row not found in combined charge");
                return;
            }

            const revertPayload = [{
                sap_id: combinedItem.sap_id,
                job_line_id: jobLineId
            }];

            const response = await axiosInstance.post('/invoice/revertcharges', {
                revert_data: revertPayload
            });

            if (response.data.success) {
                const remainingRows = combinedItem.original_rows?.filter(
                    row => row.job_line_id !== jobLineId
                ) || [];

                if (remainingRows.length === 0) {
                    setCombinedCharges(prev => prev.filter(item => item.combinedId !== combinedId));
                    setSelectedCombinedIds(prev => prev.filter(id => id !== combinedId));
                } else {
                    setCombinedCharges(prev => prev.map(item => {
                        if (item.combinedId === combinedId) {
                            const totalNetTotal = remainingRows.reduce(
                                (sum, row) => sum + (parseFloat(row.net_total) || 0), 0
                            );
                            const totalQuantity = remainingRows.reduce(
                                (sum, row) => sum + (parseFloat(row.unit_of_quantity) || 0), 0
                            );

                            return {
                                ...item,
                                original_rows: remainingRows,
                                job_line_ids: remainingRows.map(row => row.job_line_id),
                                combined_net_total: totalNetTotal,
                                combined_rate: totalNetTotal / (totalQuantity || 1),
                                combined_quantity: 1
                            };
                        }
                        return item;
                    }));
                }

                if (response.data.data && response.data.data.length > 0) {
                    setGroupedData(prev => {
                        const updated = [...prev];

                        response.data.data.forEach(group => {
                            group.rows.forEach(revertedRow => {
                                const existingGroup = updated.find(g => g.sap_id === revertedRow.sap_id);

                                if (existingGroup) {
                                    const rowExists = existingGroup.rows.some(
                                        r => r.job_line_id === revertedRow.job_line_id
                                    );

                                    if (!rowExists) {
                                        const originalRow =
                                            combinedItem.original_rows.find(r => r.job_line_id === revertedRow.job_line_id);

                                        existingGroup.rows.push({
                                            ...revertedRow,
                                            plant_code: revertedRow.plant_code ?? originalRow?.plant_code ?? "",
                                            project_code: revertedRow.project_code ?? originalRow?.project_code ?? "",
                                            sap_code: revertedRow.sap_code ?? originalRow?.sap_code ?? "",
                                            description: revertedRow.description ?? originalRow?.description ?? "",
                                            isCombined: false,
                                            isChecked: false,
                                            uniqueId: `${revertedRow.job_line_id}_${revertedRow.sap_id}_${revertedRow.job_id}`
                                        });

                                    } else {
                                        existingGroup.rows = existingGroup.rows.map(row =>
                                            row.job_line_id === revertedRow.job_line_id ? {
                                                ...revertedRow,
                                                isCombined: false,
                                                isChecked: false,
                                                uniqueId: `${revertedRow.job_line_id}_${revertedRow.sap_id}_${revertedRow.job_id}`
                                            } : row
                                        );
                                    }
                                } else {
                                    updated.push({
                                        sap_id: revertedRow.sap_id,
                                        sap_code: revertedRow.sap_code,
                                        sap_description: revertedRow.sap_description,
                                        job_ids: [revertedRow.job_id],
                                        charge_ids: [revertedRow.charge_id],
                                        rows: [{
                                            ...revertedRow,
                                            isCombined: false,
                                            isChecked: false,
                                            uniqueId: `${revertedRow.job_line_id}_${revertedRow.sap_id}_${revertedRow.job_id}`
                                        }],
                                        total_quantity: revertedRow.unit_of_quantity,
                                        total_net_total: revertedRow.net_total,
                                        total_accrual: revertedRow.accrual
                                    });
                                }
                            });
                        });

                        return updated.map(group => ({
                            ...group,
                            total_quantity: group.rows
                                .filter(row => !row.isCombined)
                                .reduce((sum, row) => sum + (parseFloat(row.unit_of_quantity) || 0), 0),
                            total_net_total: group.rows
                                .filter(row => !row.isCombined)
                                .reduce((sum, row) => sum + (parseFloat(row.net_total) || 0), 0),
                            total_accrual: group.rows
                                .filter(row => !row.isCombined)
                                .reduce((sum, row) => sum + (parseFloat(row.accrual) || 0), 0)
                        }));
                    });
                }

                toast.success("Charge reverted successfully");
            } else {
                toast.error("Failed to revert charge");
            }
        } catch (error) {
            console.error("Error reverting single charge:", error);
            toast.error("Error reverting charge");
        }
    };

    const toggleExpand = (combinedId) => {
        setExpandedRows(prev =>
            prev.includes(combinedId)
                ? prev.filter(id => id !== combinedId)
                : [...prev, combinedId]
        );
    };

    const handleCombinedCheckboxChange = (combinedId) => {
        setSelectedCombinedIds(prev =>
            prev.includes(combinedId)
                ? prev.filter(id => id !== combinedId)
                : [...prev, combinedId]
        );
    };

    const confirmRevert = () => {
        if (chargeToRevertId) {
            handleRevert(chargeToRevertId);
        }
        setOpenRevertPopup(false);
        setChargeToRevertId(null);
    };

    const cancelRevert = () => {
        setOpenRevertPopup(false);
        setChargeToRevertId(null);
    };

    const getGroupTotals = (group) => {
        const selectedRows = getGroupSelectedRows(group);

        return {
            quantity: selectedRows.reduce((sum, row) => sum + (parseFloat(row.unit_of_quantity) || 0), 0),
            net_total: selectedRows.reduce((sum, row) => sum + (parseFloat(row.net_total) || 0), 0),
            accrual: selectedRows.reduce((sum, row) => sum + (parseFloat(row.accrual) || 0), 0)
        };
    };

    const hasUncombinedRows = useMemo(() => {
        return groupedData.some(group =>
            group.rows.some(row => !row.isCombined)
        );
    }, [groupedData]);

    const handleCombinedInvoice = () => {
        toast.info("Combined Invoice functionality to be implemented");
    };

    const resetMergedChargesState = () => {
        // 🔹 Core data
        setGroupedData([]);
        setCombinedCharges([]);
        setIsCombining(false);
        setSelectedCombinedIds([]);
        setExpandedRows([]);
        setOpenRevertPopup(false);
        setChargeToRevertId(null);
        setIsGenerateSeparatePopupOpen(false);
        setSeparateChargesData([]);
        setIsLoadingSeparateCharges(false);
        setOpenSubmitDialog(false);
        setOpenConfirmDialog(false);
        setOpenSeparateConfirmDialog(false);
        setSubmitting(false);
        setBillingNature("");
        setSupplyPeriod(null);
        setBackdatedDate(null);
        setSalesHeaderRemarks("");
        setSubmitErrors({
            remarks: "",
            billingNature: "",
            supplyPeriod: "",
            backdatedDate: ""
        });
    };

    useEffect(() => {
        if (!isOpen) {
            resetMergedChargesState();
        }
    }, [isOpen]);

    const getSelectedCombinedItems = () =>
        combinedCharges.filter(item =>
            selectedCombinedIds.includes(item.combinedId)
        );

    const getSelectedMergedRows = () => {
        const rows = [];
        groupedData.forEach(group => {
            group.rows.forEach(row => {
                if (row.isChecked && !row.isCombined) {
                    rows.push(row);
                }
            });
        });
        return rows;
    };

    const getBaseProjectCode = (projectCode = "") =>
        projectCode.split("-")[0];

    const buildCombineSeparatePayload = () => {
        const payload = [];

        getSelectedCombinedItems().forEach(item => {
            payload.push({
                job_line_ids: item.job_line_ids.join(","),
                project_id: getBaseProjectCode(item.project_code), 
                plant_id: item.plant_code,
                bill_date: backdatedDate
                    ? formatDate(backdatedDate, true)
                    : "",
                supply_period: formatSupplyPeriod(supplyPeriod),
                billing_nature: billingNature || "",
                remarks: salesHeaderRemarks || "",
                po_wo_no: item.po_wo_number || "",
                po_wo_date: item.po_wo_date || "",
                material_code: item.sap_code || "",
                description_of_charges: item.sap_description || "",
                unit_qty: item.combined_quantity,
                unit_rate_price: item.combined_rate,
                net_total: item.combined_net_total,
            });
        });

        getSelectedMergedRows().forEach(row => {
            payload.push({
                job_line_ids: `${row.job_line_id}`,
                project_id: getBaseProjectCode(row.project_code), 
                plant_id: row.plant_code,
                bill_date: backdatedDate
                    ? formatDate(backdatedDate)
                    : "",
                supply_period: formatSupplyPeriod(supplyPeriod) || "",
                billing_nature: billingNature || "",
                remarks: salesHeaderRemarks || "",
                po_wo_no: row.po_wo_number || "",
                po_wo_date: row.po_wo_date || "",
                material_code: row.sap_code || "",
                description_of_charges: row.sap_description,
                unit_qty: row.unit_of_quantity,
                unit_rate_price: row.unit_of_rate,
                net_total: row.net_total,
            });
        });

        console.log("🔥 FINAL combine_separate PAYLOAD:", payload);
        return payload;
    };


    const buildJobsPayload = () => {
        const jobsMap = {};

        getSelectedCombinedItems().forEach(item => {
            item.original_rows.forEach(row => {
                if (!jobsMap[row.job_id]) {
                    jobsMap[row.job_id] = {
                        id: row.job_id,
                        jobnumber: row.job_number,
                        project_id: projectId,
                        job_type_id: row.job_type_id,
                        job_created_date: new Date().toISOString().split("T")[0],
                        ff_plant_id: row.ff_plant_id,
                        job_line: []
                    };
                }

                jobsMap[row.job_id].job_line.push({
                    project_id: projectId,
                    job_type_id: row.job_type_id,
                    job_line_id: row.job_line_id,
                    charge_id: row.charge_id,
                    description_of_charges: row.description,
                    po_wo_number: row.po_wo_number,
                    po_wo_date: row.po_wo_date,
                    unit_of_quantity: row.unit_of_quantity,
                    accrual: row.accrual,
                    remarks: row.remarks,
                    unit_of_rate: row.unit_of_rate,
                    net_total: row.net_total,
                    contract_value: row.contract_value,
                });
            });
        });

        getSelectedMergedRows().forEach(row => {
            if (!jobsMap[row.job_id]) {
                jobsMap[row.job_id] = {
                    id: row.job_id,
                    jobnumber: row.job_number,
                    project_id: projectId,
                    job_type_id: row.job_type_id,
                    job_created_date: new Date().toISOString().split("T")[0],
                    ff_plant_id: row.ff_plant_id,
                    job_line: []
                };
            }

            jobsMap[row.job_id].job_line.push({
                project_id: projectId,
                job_type_id: row.job_type_id,
                job_line_id: row.job_line_id,
                charge_id: row.charge_id,
                description_of_charges: row.description,
                po_wo_number: row.po_wo_number,
                po_wo_date: row.po_wo_date,
                unit_of_quantity: row.unit_of_quantity,
                accrual: row.accrual,
                remarks: row.remarks,
                unit_of_rate: row.unit_of_rate,
                net_total: row.net_total,
                contract_value: row.contract_value,
            });
        });

        const finalJobs = Object.values(jobsMap);
        console.log("✅ FINAL JOBS PAYLOAD:", finalJobs);
        return finalJobs;
    };



    // const handleSaveAPI = async () => {
    //     setSaving(true);

    //     const payload = {
    //         jobs: buildJobsPayload(),
    //         actions: ["save"],
    //         invoice_target: "sales",
    //         invoice_mode: "combine_separate",
    //         generate_invoice: "1",
    //         combine_separate: buildCombineSeparatePayload()
    //     };

    //     try {

    //         const res = await axiosInstance.post("/invoice/save", {
    //             data: JSON.stringify(payload)
    //         });

    //         // ✅ navigate only when backend returns success=true
    //         if (res.data?.success) {
    //             toast.success("Saved Successfully!");
    //             resetMergedChargesState();
    //             onClose();
    //             navigate("/salesInvoice");
    //         } else {
    //             toast.error(res.data?.message || "Save Failed!");
    //         }

    //     } catch (err) {
    //         toast.error("Save Failed!");
    //     } finally {
    //         setSaving(false);
    //         setOpenSaveDialog(false);
    //     }
    // };

    const handleSubmitClick = () => {
        const hasSelectedMergedCharges = groupedData.some(group =>
            group.rows.some(row => row.isChecked && !row.isCombined)
        );

        const hasSelectedCombinedCharges = selectedCombinedIds.length > 0;

        if (!hasSelectedMergedCharges && !hasSelectedCombinedCharges) {
            toast.warning("Please select at least one charge to submit");
            return;
        }

        if (hasSelectedMergedCharges) {
            setOpenConfirmDialog(true);
        } else {
            setOpenSubmitDialog(true);
        }
    };

    const getInvoiceMeta = () => {
        const combinedItems = getSelectedCombinedItems();
        const mergedRows = getSelectedMergedRows();
        let jobTypeDivision = "";

        if (combinedItems.length > 0) {
            const row = combinedItems[0]?.original_rows?.[0];
            jobTypeDivision = row?.job_type_division?.toLowerCase() || "";
        }
        else if (mergedRows.length > 0) {
            const row = mergedRows[0];
            jobTypeDivision = row?.job_type_division?.toLowerCase() || "";
        }

        return {jobTypeDivision };
    };

    const handleSubmitAPI = async () => {
        // const isValid = validateSubmitForm();
        // if (!isValid) return;

        setSubmitting(true);
        const {jobTypeDivision } = getInvoiceMeta();
        const payload = {
            jobs: buildJobsPayload(),
            actions: ["submit"],
            invoice_target: "sales",
            invoice_mode: "combine_separate",
            generate_invoice: "1",
            billing_nature: billingNature || "",
            backdated_date: backdatedDate
                ? formatBackdatedDate(backdatedDate)
                : null,
            supply_period: formatSupplyPeriod(supplyPeriod),
            sales_header_remarks: salesHeaderRemarks || "",
            division_type: jobTypeDivision,
            combine_separate: buildCombineSeparatePayload(),    
        };

        try {
            const res = await axiosInstance.post("/invoice/save", {
                data: JSON.stringify(payload)
            });

            // ✅ navigate only on success
            if (res.data?.success) {
                toast.success("Submitted Successfully!");
                resetMergedChargesState();
                sessionStorage.removeItem("mergedChargesData");
                sessionStorage.removeItem("mergedChargesData");
                console.log("jobLineIdMap cleared after successful merge");
                onClose();
                navigate("/salesInvoice");
            } else {
                toast.error(res.data?.message || "Submit Failed!");
            }

        } catch (err) {
            toast.error("Submit Failed!");
        } finally {
            setSubmitting(false);
            setOpenSubmitDialog(false);
        }
    };


    const handleConfirmSubmit = () => {
        setOpenConfirmDialog(false);
        setOpenSubmitDialog(true);
    };

    const handleMergedSeparateInvoice = async () => {
        try {
            setIsLoadingSeparateCharges(true);

            // Check if any combined OR merged charges are selected
            const hasSelectedCombinedCharges = selectedCombinedIds.length > 0;
            const hasSelectedMergedCharges = groupedData.some(group =>
                group.rows.some(row => row.isChecked && !row.isCombined)
            );

            if (!hasSelectedCombinedCharges && !hasSelectedMergedCharges) {
                toast.warning("Please select at least one combined or merged charge to create separate invoices");
                return;
            }

            if (hasSelectedMergedCharges) {
                setOpenSeparateConfirmDialog(true);
                setIsLoadingSeparateCharges(false);
                return;
            }

            // Proceed with separate invoice generation
            await proceedWithSeparateInvoice();

        } catch (error) {
            console.error("❌ Separate Invoice Error:", error);
            toast.error("Error generating separate invoice");
        } finally {
            setIsLoadingSeparateCharges(false);
        }
    };

    const handleConfirmSeparateInvoice = async () => {
        setOpenSeparateConfirmDialog(false);
        await proceedWithSeparateInvoice();
    };

    const proceedWithSeparateInvoice = async () => {
        const selectedCombinedItems = combinedCharges.filter(item =>
            selectedCombinedIds.includes(item.combinedId)
        );

        const selectedMergedRows = [];
        groupedData.forEach(group => {
            group.rows.forEach(row => {
                if (row.isChecked && !row.isCombined) {
                    selectedMergedRows.push({
                        ...row,
                        isCombined: false
                    });
                }
            });
        });

        if (selectedCombinedItems.length === 0 && selectedMergedRows.length === 0) {
            toast.warning("No charges selected");
            return;
        }

        console.log("📊 Selected Combined Items:", selectedCombinedItems);
        console.log("📊 Selected Merged Rows:", selectedMergedRows);

        const jobsMap = {};

        selectedCombinedItems.forEach(item => {
            item.original_rows.forEach(row => {
                if (!jobsMap[row.job_id]) {
                    jobsMap[row.job_id] = {
                        job_id: row.job_id,
                        job_line_ids: []
                    };
                }
                if (!jobsMap[row.job_id].job_line_ids.includes(row.job_line_id)) {
                    jobsMap[row.job_id].job_line_ids.push(row.job_line_id);
                }
            });
        });

        // Add merged items to jobsMap
        selectedMergedRows.forEach(row => {
            if (!jobsMap[row.job_id]) {
                jobsMap[row.job_id] = {
                    job_id: row.job_id,
                    job_line_ids: []
                };
            }
            if (!jobsMap[row.job_id].job_line_ids.includes(row.job_line_id)) {
                jobsMap[row.job_id].job_line_ids.push(row.job_line_id);
            }
        });

        const jobsPayload = Object.values(jobsMap);

        const combineSeparatePayload = [];

        selectedCombinedItems.forEach(item => {
            combineSeparatePayload.push({
                job_line_ids: item.job_line_ids.join(","),
                project_id: getBaseProjectCode(item.project_code),
                plant_id: item.plant_code,
                supply_period: "",
                billing_nature: "",
                po_wo_no: item.po_wo_number || "",
                po_wo_date: item.po_wo_date || "",
                material_code: item.sap_code,
                description_of_charges: item.sap_description,
                unit_qty: item.combined_quantity,
                unit_rate_price: item.combined_rate,
                net_total: item.combined_net_total,
                remarks: item.combined_remarks || ""
            });
        });

        selectedMergedRows.forEach(row => {
            combineSeparatePayload.push({
                job_line_ids: `${row.job_line_id}`,
                project_id: getBaseProjectCode(row.project_code),
                plant_id: row.plant_code,
                supply_period: "",
                billing_nature: "",
                po_wo_no: row.po_wo_number || "",
                po_wo_date: row.po_wo_date || "",
                material_code: row.sap_code || "",
                description_of_charges: row.sap_description,
                unit_qty: row.unit_of_quantity,
                unit_rate_price: row.unit_of_rate,
                net_total: row.net_total,
                remarks: row.remarks || ""
            });
        });

        console.log("🚀 Final payload for Separate Invoice API:", {
            jobs: jobsPayload,
            combine_separate: combineSeparatePayload
        });

        try {
            const response = await axiosInstance.post(
                "/job/generate_multi_sales_line_invoice",
                {
                    jobs: jobsPayload,
                    combine_separate_multiple: combineSeparatePayload
                }
            );

            console.log("📦 API Response:", response.data);

            if (response.data.success) {
                toast.success("Separate Invoice generated!");

                // Add a flag to identify which items came from merged vs combined
                const enhancedData = response.data;

                // Mark items in combine_separate array with their source
                if (enhancedData.combine_separate && Array.isArray(enhancedData.combine_separate)) {
                    enhancedData.combine_separate = enhancedData.combine_separate.map((item, index) => {
                        // Check if this item came from combined charges (has comma in job_line_ids)
                        const isFromCombined = item.job_line_ids.includes(",");
                        return {
                            ...item,
                            source: isFromCombined ? "combined" : "merged",
                            originalIndex: index
                        };
                    });
                }

                setSeparateChargesData(enhancedData);
                setIsGenerateSeparatePopupOpen(true);
            } else {
                toast.error("Failed to generate separate invoice");
            }
        } catch (error) {
            console.error("Error generating separate invoice:", error);
            toast.error("Error generating separate invoice");
        }
    };

    const getMinBackdatedDate = (currentDate, days) => {
        const minDate = new Date(currentDate);
        minDate.setDate(minDate.getDate() - days);
        return minDate;
    };

    const formatDate = (d, isPicker = false) => {
        if (!d) return "";

        const date = isPicker
            ? new Date(d.getTime() - d.getTimezoneOffset() * 60000)
            : new Date(d);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}.${month}.${year}`;
    };

    const formatBackdatedDate = (d) => {
        if (!d) return null;

        const date = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
        return date.toISOString().split("T")[0];
    };


    const formatSupplyPeriod = (date) => {
        if (!date) return "";

        const month = date.toLocaleString("en-US", { month: "short" });
        const year = date.getFullYear();

        return `${month}-${year}`;
    };

    const getFinalSalesCsvRows = () => {
        const rows = [];
        combinedCharges
            .filter(item => selectedCombinedIds.includes(item.combinedId))
            .forEach(item => {
                rows.push({
                    type: "combined",
                    project: getBaseProjectCode(item.project_code),
                    chargeCode: item.charge_code,
                    materialCode: item.sap_code,
                    description: item.sap_description,
                    plantCode: item.plant_code,
                    qty: item.combined_quantity,
                    rate: item.combined_rate,
                    netTotal: item.combined_net_total,
                });
            });

        groupedData.forEach(group => {
            group.rows
                .filter(row => row.isChecked && !row.isCombined)
                .forEach(row => {
                    rows.push({
                        type: "merged",
                        project: getBaseProjectCode(row.project_code),
                        chargeCode: row.charge_code,
                        materialCode: row.sap_code,
                        description: row.sap_description,
                        plantCode: row.plant_code || row.plantCode,
                        qty: row.unit_of_quantity,
                        rate: row.unit_of_rate,
                        netTotal: row.net_total,
                    });
                });
        });

        return rows;
    };

    const allCombinedIds = combinedCharges.map(c => c.combinedId);

    const isAllCombinedSelected =
        allCombinedIds.length > 0 &&
        allCombinedIds.every(id => selectedCombinedIds.includes(id));

    const isSomeCombinedSelected =
        selectedCombinedIds.length > 0 && !isAllCombinedSelected;

    const handleCombinedHeaderCheckbox = () => {
        if (isAllCombinedSelected) {
            setSelectedCombinedIds([]);
        } else {
            setSelectedCombinedIds(allCombinedIds);
        }
    };

    // const validateSubmitForm = () => {
    //     const errors = {};

    //     if (!salesHeaderRemarks.trim()) {
    //         errors.remarks = "Remarks to Customer is required";
    //     }

    //     if (!billingNature.trim()) {
    //         errors.billingNature = "Billing Nature is required";
    //     }

    //     if (!supplyPeriod) {
    //         errors.supplyPeriod = "Supply Period is required";
    //     }

    //     // if (!backdatedDate) {
    //     //     errors.backdatedDate = "Backdated Date is required";
    //     // }

    //     setSubmitErrors(errors);

    //     return Object.keys(errors).length === 0;
    // };

    if (!isOpen) return null;

    return (
        <>
            <div className="merged-list-overlay">
                <div className="merged-list-container" style={{ overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth' }}>

                    {/* Combined Charges Section - Only shown after combining */}
                    {combinedCharges.length > 0 && (
                        <div className="combine-charges-wrapper">
                            <div className="combine-charges-header sticky-header">
                                <div className="combine-charges-left">
                                    <h2>Combined Charges</h2>
                                    <div className="combine-charges-info">
                                        <span className="combine-charges-info-icon">!</span>
                                        <span>
                                            Select the combined/uncombined charges to proceed with the final invoice creation.
                                        </span>
                                    </div>
                                </div>
                                <div className="combine-charges-right-buttons">
                                    <button
                                        className="combine-charges-btn"
                                        onClick={handleMergedSeparateInvoice}
                                        disabled={isLoadingSeparateCharges}
                                        style={{
                                            cursor: isLoadingSeparateCharges ? "not-allowed" : "pointer",
                                            opacity: isLoadingSeparateCharges ? 0.6 : 1
                                        }}
                                    >
                                        {isLoadingSeparateCharges ? "Loading..." : "Separate Invoice"}
                                    </button>
                                    {/* <button
                                        className="combine-charges-btn"
                                        onClick={handleCombinedInvoice}
                                    >
                                        Combined Invoice
                                    </button> */}
                                </div>
                            </div>

                            <div className="merged-list-content" style={{ overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth' }}>

                                <div className="invoice_popup_outercategory" style={{ backgroundColor: '#FFF7E8' }}>
                                    <div className="invoice_popup_category_subheader">
                                        <div className="invoice_popup_element_list" style={{ overflowX: "auto" }}>
                                            <div className="table-container" style={{ position: "relative" }}>
                                                <table className="invoice_table">
                                                    <thead>
                                                        <tr>
                                                            <th
                                                                style={{
                                                                    backgroundColor: "#E6E9EE",
                                                                    width: "40px",
                                                                    minWidth: "40px",
                                                                    maxWidth: "40px",
                                                                    textAlign: "center"
                                                                }}
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    checked={isAllCombinedSelected}
                                                                    ref={el => {
                                                                        if (el) el.indeterminate = isSomeCombinedSelected;
                                                                    }}
                                                                    onChange={handleCombinedHeaderCheckbox}
                                                                    style={{ width: "15px", height: "15px", margin: "0 auto" }}
                                                                />
                                                            </th>

                                                            <th colSpan={2} style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>ACTIVITY</th>
                                                            <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>S.NO</th>
                                                            <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>PROJECT</th>
                                                            <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>CHARGE CODE</th>
                                                            <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>MATERIAL CODE</th>
                                                            <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>DESCRIPTION OF CHARGES</th>
                                                            <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>PLANT CODE</th>
                                                            {/* <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>PO/WO NO</th>
                                                            <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>PO/WO DATE</th> */}
                                                            <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>QTY</th>
                                                            <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>RATE</th>
                                                            <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>NET TOTAL</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {combinedCharges.map((combinedItem, index) => {
                                                            const originalRows = combinedItem.original_rows || [];
                                                            const totalQuantity = originalRows.reduce((sum, row) => sum + (parseFloat(row.unit_of_quantity) || 0), 0);
                                                            const totalNetTotal = originalRows.reduce((sum, row) => sum + (parseFloat(row.net_total) || 0), 0);
                                                            const weightedRate = totalQuantity > 0 ? totalNetTotal / totalQuantity : 0;
                                                            const isExpanded = expandedRows.includes(combinedItem.combinedId);

                                                            return (
                                                                <React.Fragment key={combinedItem.combinedId}>
                                                                    <tr>
                                                                        <td style={{ width: "40px", minWidth: "40px", maxWidth: "40px", textAlign: "center", padding: "8px 0" }}>
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={selectedCombinedIds.includes(combinedItem.combinedId)}
                                                                                onChange={() => handleCombinedCheckboxChange(combinedItem.combinedId)}
                                                                                style={{ width: "15px", height: "15px", margin: "0 auto" }}
                                                                            />
                                                                        </td>
                                                                        <td style={{ textAlign: "center" }}>
                                                                            <span
                                                                                style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                                                                                onClick={() => {
                                                                                    setChargeToRevertId(combinedItem.combinedId);
                                                                                    setOpenRevertPopup(true);
                                                                                }}
                                                                            >
                                                                                <img src={delete_icon} alt="Delete" />
                                                                            </span>
                                                                        </td>
                                                                        <td style={{ textAlign: "center" }}>
                                                                            <div
                                                                                style={{
                                                                                    display: "inline-flex",
                                                                                    alignItems: "center",
                                                                                    gap: "8px",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                                onClick={() => toggleExpand(combinedItem.combinedId)}
                                                                            >
                                                                                <img
                                                                                    src={isExpanded ? expanded_icon : edit_icon}
                                                                                    alt={isExpanded ? "Expanded" : "Edit"}
                                                                                    style={{
                                                                                        width: "16px",
                                                                                        height: "16px",
                                                                                        display: "block"
                                                                                    }}
                                                                                />

                                                                                <span
                                                                                    style={{
                                                                                        minWidth: "22px",
                                                                                        height: "22px",
                                                                                        borderRadius: "11px",
                                                                                        backgroundColor: "#E0EDFF",
                                                                                        color: "#1D4ED8",
                                                                                        fontSize: "11px",
                                                                                        fontWeight: 600,
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center",
                                                                                        lineHeight: "1"
                                                                                    }}
                                                                                >
                                                                                    {combinedItem.original_rows?.length || 0}
                                                                                </span>
                                                                            </div>
                                                                        </td>

                                                                        <td>{index + 1}</td>
                                                                        <td>{combinedItem.project_code}</td>
                                                                        <td>{combinedItem.charge_code}</td>
                                                                        <td style={{ padding: "10px" }}>{combinedItem.sap_code}</td>
                                                                        <td>{combinedItem.sap_description}</td>
                                                                        <td>{combinedItem.plant_code}</td>
                                                                        {/* <td>{combinedItem.po_wo_number || '--'}</td>
                                                                        <td>{combinedItem.po_wo_date || '--'}</td> */}
                                                                        <td>{combinedItem.combined_quantity}</td>
                                                                        <td>{combinedItem.combined_rate}</td>
                                                                        <td>{combinedItem.combined_net_total}</td>
                                                                    </tr>

                                                                    {isExpanded && (
                                                                        <>
                                                                            {combinedItem.original_rows.map((row, rowIndex) => (
                                                                                <tr key={`expanded-${rowIndex}`}>
                                                                                    <td colSpan={14} style={{ padding: "10px 0 10px 20px" }}>
                                                                                        <div
                                                                                            style={{
                                                                                                background: "#E6FFE6",
                                                                                                borderRadius: "14px",
                                                                                                padding: "10px 20px",
                                                                                                display: "flex",
                                                                                                alignItems: "center",
                                                                                                gap: "30px",
                                                                                                borderLeft: "4px solid #9BE3A4"
                                                                                            }}
                                                                                        >
                                                                                            {/* Delete Icon */}
                                                                                            <div
                                                                                                style={{
                                                                                                    width: "15px",
                                                                                                    height: "15px",
                                                                                                    borderRadius: "50%",
                                                                                                    backgroundColor: "#FFF",
                                                                                                    display: "flex",
                                                                                                    alignItems: "center",
                                                                                                    justifyContent: "center",
                                                                                                    boxShadow: "0px 1px 3px rgba(0,0,0,0.15)",
                                                                                                    cursor: 'pointer'
                                                                                                }}
                                                                                                onClick={() => handleRevertSingle(combinedItem.combinedId, row.job_line_id)}
                                                                                            >
                                                                                                <img
                                                                                                    src={delete_icon}
                                                                                                    alt="delete"
                                                                                                    style={{ width: "20px", height: "20px" }}
                                                                                                />
                                                                                            </div>

                                                                                            <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>

                                                                                                <div>
                                                                                                    <div style={{ fontSize: "10px", color: "#7A7A7A", marginBottom: "8px" }}>JOB NUMBER</div>
                                                                                                    <div style={{ fontWeight: 600 }}>{row.job_number}</div>
                                                                                                </div>

                                                                                                <div>
                                                                                                    <div style={{ fontSize: "10px", color: "#7A7A7A", marginBottom: "8px" }}>CHARGE CODE</div>
                                                                                                    <div style={{ fontWeight: 600 }}>{row.charge_code}</div>
                                                                                                </div>

                                                                                                <div>
                                                                                                    <div style={{ fontSize: "10px", color: "#7A7A7A", marginBottom: "8px" }}>DESCRIPTION</div>
                                                                                                    <div>{row.description}</div>
                                                                                                </div>

                                                                                                <div>
                                                                                                    <div style={{ fontSize: "10px", color: "#7A7A7A", marginBottom: "8px" }}>REMARKS</div>
                                                                                                    <div>{row.remarks || "--:--"}</div>
                                                                                                </div>

                                                                                                {/* <div>
                                                                                                    <div style={{ fontSize: "10px", color: "#7A7A7A", marginBottom: "8px" }}>PO/WO NUMBER</div>
                                                                                                    <div>{row.po_wo_number || "--:--"}</div>
                                                                                                </div>

                                                                                                <div>
                                                                                                    <div style={{ fontSize: "10px", color: "#7A7A7A", marginBottom: "8px" }}>PO/WO DATE</div>
                                                                                                    <div>{row.po_wo_date || "--:--"}</div>
                                                                                                </div> */}

                                                                                                <div>
                                                                                                    <div style={{ fontSize: "10px", color: "#7A7A7A", marginBottom: "8px" }}>ACCRUAL SPLIT</div>
                                                                                                    <div>{row.accrual}</div>
                                                                                                </div>

                                                                                                {/* <div>
                                                                                                    <div style={{ fontSize: "10px", color: "#7A7A7A", marginBottom: "8px" }}>CONTRACT VALUE</div>
                                                                                                    <div>{row.contract_value}</div>
                                                                                                </div> */}

                                                                                                <div style={{ minWidth: "80px" }}>
                                                                                                    <div style={{ fontSize: "10px", color: "#7A7A7A", marginBottom: "8px" }}>QUANTITY</div>
                                                                                                    <div>{row.unit_of_quantity}</div>
                                                                                                </div>

                                                                                                <div >
                                                                                                    <div style={{ fontSize: "10px", color: "#7A7A7A", marginBottom: "8px" }}>RATE</div>
                                                                                                    <div>{row.unit_of_rate?.toLocaleString()}</div>
                                                                                                </div>

                                                                                                <div>
                                                                                                    <div style={{ fontSize: "10px", color: "#7A7A7A", marginBottom: "8px" }}>NET TOTAL</div>
                                                                                                    <div>{row.net_total?.toLocaleString()}</div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </>
                                                                    )}
                                                                </React.Fragment>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Merged Charges Section - Always shown initially */}
                    <div className="merged-charges-wrapper">
                        <div className="merged-list-header sticky-header">
                            <div className="merged-left">
                                <h2>
                                    {combinedCharges.length > 0
                                        ? "Uncombined Charges"
                                        : "Charges Grouped by SAP Code"}
                                </h2>
                                <div className="merged-info">
                                    <span className="info-icon">!</span>
                                    <span>
                                        Select the charges to combine. Unselected charges will remain in their respective jobs.
                                    </span>
                                </div>
                            </div>
                            <div className="merged-right-buttons">
                                <button
                                    className="combine-btn"
                                    onClick={handleCombine}
                                    disabled={isCombining || !getSelectedRows().length}
                                    style={{
                                        cursor: (isCombining || !getSelectedRows().length) ? "not-allowed" : "pointer",
                                        opacity: (isCombining || !getSelectedRows().length) ? 0.6 : 1
                                    }}
                                >
                                    {isCombining ? "Combining..." : "Combine"}
                                </button>
                                <div
                                    className="merged-close-btn"
                                    onClick={() => {
                                        resetMergedChargesState();
                                        onClose();
                                    }}
                                >
                                    <X size={16} />
                                </div>
                            </div>
                        </div>

                        <div className="merged-list-content" style={{ overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth' }}>
                            {hasUncombinedRows ? (
                                groupedData
                                    .filter(group => group.rows.some(row => !row.isCombined))
                                    .map((group) => {
                                        const totals = getGroupTotals(group);
                                        const allRowsUncombined = group.rows.filter(row => !row.isCombined);
                                        const allChecked = allRowsUncombined.length > 0 &&
                                            allRowsUncombined.every(row => row.isChecked);

                                        return (
                                            <div key={`group-${group.sap_id}`} className="invoice_popup_outercategory">
                                                <div className="invoice_popup_category_header">
                                                    <div className="category_name_left"
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            gap: "8px",
                                                        }}
                                                    >
                                                        <div style={{
                                                            display: "flex",
                                                            gap: "10px",
                                                            fontSize: "11px",
                                                            alignItems: "center",
                                                            overflowX: "auto",
                                                            justifyContent: "flex-start"
                                                        }}>
                                                            {group.sap_code && (
                                                                <div style={{
                                                                    backgroundColor: "#ffffff",
                                                                    borderRadius: "8px",
                                                                    padding: "6px 12px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "6px",
                                                                    height: "30px",
                                                                    whiteSpace: "nowrap",
                                                                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                                                }}>
                                                                    <span style={{ color: "#C89C00", fontWeight: 600 }}>SAP CODE :</span>
                                                                    <span style={{ color: "#000" }}>{group.sap_code}</span>
                                                                </div>
                                                            )}

                                                            {group.sap_description && (
                                                                <div style={{
                                                                    backgroundColor: "#ffffff",
                                                                    borderRadius: "8px",
                                                                    padding: "6px 12px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "6px",
                                                                    height: "30px",
                                                                    whiteSpace: "nowrap",
                                                                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                                                }}>
                                                                    <span style={{ color: "green", fontWeight: 600 }}>SAP DESCRIPTION :</span>
                                                                    <span style={{ color: "#000" }}>{group.sap_description}</span>
                                                                </div>
                                                            )}

                                                            <div style={{
                                                                backgroundColor: "#ffffff",
                                                                borderRadius: "8px",
                                                                padding: "6px 12px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "6px",
                                                                height: "30px",
                                                                whiteSpace: "nowrap",
                                                                boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                                            }}>
                                                                <span style={{ color: "#FF6B6B", fontWeight: 600 }}>TOTAL SELECTED :</span>
                                                                <span style={{ color: "#000" }}>
                                                                    Qty: {totals.quantity.toFixed(2)} |
                                                                    Net: ₹ {totals.net_total.toFixed(2)} |
                                                                    Accrual: ₹ {totals.accrual.toFixed(2)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="invoice_popup_category_subheader">
                                                    <div className="invoice_popup_element_list" style={{ overflowX: "auto" }}>
                                                        <div className="table-container" style={{ position: "relative" }}>
                                                            <table className="invoice_table">
                                                                <thead>
                                                                    <tr>
                                                                        <th
                                                                            rowSpan="2"
                                                                            style={{ width: "40px", minWidth: "40px", maxWidth: "40px", textAlign: "center", backgroundColor: "#D9FFE2" }}
                                                                        >
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={allChecked}
                                                                                onChange={() => handleGroupCheckboxChange(group.sap_id)}
                                                                                disabled={allRowsUncombined.length === 0}
                                                                                style={{ width: "15px", height: "15px", margin: "0 auto" }}
                                                                            />
                                                                        </th>
                                                                        <th
                                                                            colSpan="14"
                                                                            style={{
                                                                                backgroundColor: "#D9FFE2",
                                                                                padding: "10px",
                                                                                color: "#008B1F",
                                                                                textAlign: "center",
                                                                            }}
                                                                        >
                                                                            SALES
                                                                        </th>
                                                                    </tr>
                                                                    <tr>
                                                                        <th style={{ backgroundColor: "#D9FFE2", textAlign: "center" }}>S.NO</th>
                                                                        <th style={{ backgroundColor: "#D9FFE2", textAlign: "center" }}>JOB NUMBER</th>
                                                                        <th style={{ backgroundColor: "#D9FFE2", textAlign: "center" }}>JOB TYPE</th>
                                                                        <th style={{ backgroundColor: "#D9FFE2", textAlign: "center" }}>CHARGE CODE</th>
                                                                        <th style={{ backgroundColor: "#D9FFE2", textAlign: "center" }}>DESCRIPTION</th>
                                                                        {/* <th style={{ backgroundColor: "#D9FFE2", textAlign: "center" }}>PO/WO NO</th>
                                                                        <th style={{ backgroundColor: "#D9FFE2", textAlign: "center" }}>PO/WO DATE</th> */}
                                                                        <th style={{ backgroundColor: "#D9FFE2", textAlign: "center" }}>REMARKS</th>
                                                                        <th style={{ backgroundColor: "#D9FFE2", textAlign: "center" }}>ACCRUAL SPLIT</th>
                                                                        {/* <th style={{ backgroundColor: "#D9FFE2", textAlign: "center" }}>CONTRACT VALUE</th> */}
                                                                        <th style={{ backgroundColor: "#D9FFE2", textAlign: "center" }}>QUANTITY</th>
                                                                        <th style={{ backgroundColor: "#D9FFE2", textAlign: "center" }}>RATE</th>
                                                                        <th style={{ backgroundColor: "#D9FFE2", textAlign: "center", padding: "10px" }}>NET TOTAL</th>
                                                                        {/* <th style={{ backgroundColor: "#D9FFE2", textAlign: "center", padding: "10px" }}>ATTACHMENT</th> */}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {group.rows
                                                                        .filter(row => !row.isCombined)
                                                                        .map((row, rowIndex) => (
                                                                            <tr key={row.uniqueId}>
                                                                                <td style={{ width: "40px", minWidth: "40px", maxWidth: "40px", textAlign: "center", padding: "8px 0" }}>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={row.isChecked || false}
                                                                                        onChange={() => handleRowCheckboxChange(row.uniqueId, group.sap_id)}
                                                                                        style={{ width: "15px", height: "15px", margin: "0 auto" }}
                                                                                    />
                                                                                </td>
                                                                                <td>{rowIndex + 1}</td>
                                                                                <td>{row.job_number}</td>
                                                                                <td>{row.job_type}</td>
                                                                                <td style={{ padding: '12px' }}>{row.charge_code}</td>
                                                                                <td>{row.description}</td>
                                                                                {/* <td>{row.po_wo_number || '--'}</td>
                                                                                <td>{row.po_wo_date || '--'}</td> */}
                                                                                <td>{row.remarks}</td>
                                                                                <td>{row.accrual || '0.00'}</td>
                                                                                {/* <td>{row.contract_value || '--'}</td> */}
                                                                                <td>1</td>
                                                                                <td>{Number(row.net_total).toFixed(2)}</td>
                                                                                <td>{Number(row.net_total).toFixed(2)}</td>
                                                                                {/* <td>
                                                                                    {row.attachment_url ? (
                                                                                        <a
                                                                                            href={row.attachment_url}
                                                                                            target="_blank"
                                                                                            rel="noopener noreferrer"
                                                                                            style={{ color: '#007BFF', textDecoration: 'none' }}
                                                                                        >
                                                                                            View
                                                                                        </a>
                                                                                    ) : '-'}
                                                                                </td> */}
                                                                            </tr>
                                                                        ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                            ) : (
                                <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                                    <h3>No merged charges found</h3>
                                    <p>All charges have been combined or no charges are available</p>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Combined Charges Section - Only shown after combining after these btn*/}
                    {combinedCharges.length > 0 && (
                        <div className="combined-footer-container">
                            <div className="combined-footer-actions">
                                <button className="combined-btn cancel" onClick={() => {
                                    resetMergedChargesState();
                                    onClose();
                                }}>Cancel</button>

                                {/* <button
                                    className="combined-btn save"
                                    onClick={() => setOpenSaveDialog(true)}
                                    disabled={saving}
                                >
                                    {saving ? "Saving..." : "Save"}
                                </button> */}

                                <button
                                    className="combined-btn submit"
                                    onClick={handleSubmitClick}
                                    disabled={submitting}
                                    style={{
                                        cursor: submitting ? "not-allowed" : "pointer",
                                        opacity: submitting ? 0.6 : 1
                                    }}
                                >
                                    {submitting ? "Submitting..." : "Submit"}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {openSubmitDialog && (
                <div className="merged-modal">
                    <div className="merged-modal-content submit-popup" style={{ position: "relative", padding: "10px" }}>
                        {/* HEADER */}
                        <div className="submit-header">
                            <h3>Submit Details</h3>

                            <div
                                className="merged-close-btn"
                                onClick={() => setOpenSubmitDialog(false)}
                            >
                                <X size={16} />
                            </div>
                        </div>

                        <div className="submit-body" style={{ overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth' }}>
                            <div className="submit-form-wrapper" style={{ marginTop: '10px' }}>
                                <div
                                    style={{
                                        border: "1.5px dotted #9CA3AF",
                                        backgroundColor: "#F9FAFB",
                                        padding: "15px",
                                        borderRadius: "10px",
                                        marginBottom: "10px",
                                    }}
                                >
                                    <div style={{ display: "flex", gap: "15px", marginBottom: "10px" }}>

                                        {/* Remarks to Customer */}
                                        <div style={{ flex: 1 }}>
                                            <label style={{ display: "block", fontSize: "14px", fontWeight: 600, color: "#19324C" }}>
                                                Remarks to Customer
                                            </label>

                                            <SapCsvSafeInput
                                                value={salesHeaderRemarks}
                                                onChange={(val) => {
                                                    setSalesHeaderRemarks(val);
                                                    setSubmitErrors(prev => ({ ...prev, remarks: "" }));
                                                }}
                                                maxLength={255}
                                                placeholder="Enter your Remarks..."
                                                style={{
                                                    width: "100%",
                                                    padding: "8px",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "6px",
                                                    fontSize: "13px",
                                                    fontFamily: "Work Sans",
                                                    margin: "0px"
                                                }}
                                            />
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    marginTop: "4px",
                                                    minHeight: "14px"
                                                }}
                                            >
                                                <span style={{ color: "red", fontSize: "11px" }}>
                                                    {submitErrors.remarks || ""}
                                                </span>

                                                <span style={{ fontSize: "11px", color: "#555" }}>
                                                    {salesHeaderRemarks.length}/255
                                                </span>
                                            </div>

                                        </div>


                                        {/* Billing Nature */}
                                        <div style={{ flex: 1 }}>
                                            <label style={{ display: "block", fontSize: "14px", fontWeight: 600, color: "#19324C" }}>
                                                Billing Nature
                                            </label>

                                            <SapCsvSafeInput
                                                value={billingNature}
                                                onChange={(val) => {
                                                    setBillingNature(val);
                                                    setSubmitErrors(prev => ({ ...prev, billingNature: "" }));
                                                }}
                                                maxLength={18}
                                                placeholder="Enter Billing Nature"
                                                style={{
                                                    width: "100%",
                                                    height: "33px",
                                                    padding: "6px 8px",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "6px",
                                                    fontSize: "13px",
                                                    fontFamily: "Work Sans",
                                                    margin: "0px"
                                                }}
                                            />
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    marginTop: "4px",
                                                    minHeight: "14px"
                                                }}
                                            >
                                                <span style={{ color: "red", fontSize: "11px" }}>
                                                    {submitErrors.billingNature || ""}
                                                </span>

                                                <span style={{ fontSize: "11px", color: "#555" }}>
                                                    {billingNature?.length || 0}/18
                                                </span>
                                            </div>
                                        </div>

                                        {/* Supply Period */}
                                        <div style={{ flex: 1 }}>
                                            <label style={{ display: "block", fontSize: "14px", fontWeight: 600, color: "#19324C" }}>
                                                Supply Period 
                                            </label>

                                            <DatePicker
                                                selected={supplyPeriod}
                                                onChange={(date) => {
                                                    setSupplyPeriod(date);
                                                    setSubmitErrors(prev => ({ ...prev, supplyPeriod: "" }));
                                                }}
                                                dateFormat="MMM-yyyy"
                                                showMonthYearPicker
                                                placeholderText="Select month & year"
                                                className='submit-details-datepicker'
                                                disabled  
                                            />
                                            {submitErrors.supplyPeriod && (
                                                <p style={{ color: "red", fontSize: "11px", margin: "4px 0 0" }}>
                                                    {submitErrors.supplyPeriod}
                                                </p>
                                            )}
                                        </div>

                                        {/* Backdated Date */}
                                        <div style={{ flex: 1 }}>
                                            <label style={{ display: "block", fontSize: "14px", fontWeight: 600, color: "#19324C" }}>
                                                Backdated Date
                                            </label>

                                            <DatePicker
                                                selected={backdatedDate}
                                                onChange={(date) => setBackdatedDate(date)}
                                                dateFormat="yyyy-MM-dd"
                                                placeholderText="Select a backdated date"
                                                minDate={getMinBackdatedDate(new Date(), backdatedDays)}
                                                maxDate={new Date()}
                                                className='submit-details-datepicker'
                                            />
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="submit-table-wrapper" >
                                <div
                                    className="merged-list-content"
                                    style={{
                                        overflowX: "auto",
                                        whiteSpace: "nowrap",
                                        scrollbarWidth: "none",
                                        WebkitOverflowScrolling: "touch",
                                        scrollBehavior: "smooth",
                                    }}
                                >
                                    <div className="invoice_popup_outercategory" style={{ backgroundColor: "#FFF7E8", margin: '0px' }}>
                                        <div className="invoice_popup_category_subheader">

                                            <div className="invoice_popup_element_list" style={{ overflowX: "auto" }}>
                                                <div
                                                    style={{
                                                        backgroundColor: "#19324C",
                                                        color: "#fff",
                                                        padding: "12px 16px",
                                                        fontSize: "15px",
                                                        fontWeight: 600,
                                                        borderTopLeftRadius: "8px",
                                                        borderTopRightRadius: "8px",
                                                        borderRadius: '8px'
                                                    }}
                                                >
                                                    Final Sales CSV
                                                </div>
                                                <div className="table-container" style={{ position: "relative" }}>
                                                    <table className="invoice_table">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>S.NO</th>
                                                                <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>PROJECT</th>
                                                                <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>CHARGE CODE</th>
                                                                <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>MATERIAL CODE</th>
                                                                <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>DESCRIPTION OF CHARGES</th>
                                                                <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>PLANT CODE</th>
                                                                <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>QTY</th>
                                                                <th style={{ backgroundColor: "#E6E9EE", textAlign: "center" }}>RATE</th>
                                                                <th style={{ backgroundColor: "#E6E9EE", textAlign: "center", padding: '10px' }}>NET TOTAL</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {getFinalSalesCsvRows().length === 0 ? (
                                                                <tr>
                                                                    <td colSpan={9} style={{ textAlign: "center", padding: "20px" }}>
                                                                        No charges selected
                                                                    </td>
                                                                </tr>
                                                            ) : (
                                                                getFinalSalesCsvRows().map((row, index) => (
                                                                    <tr key={index}>
                                                                        <td style={{ padding: "10px", textAlign: "center" }}>
                                                                            {index + 1}
                                                                        </td>
                                                                        <td>{row.project}</td>
                                                                        <td>{row.chargeCode}</td>
                                                                        <td>{row.materialCode}</td>
                                                                        <td>{row.description}</td>
                                                                        <td>{row.plantCode}</td>
                                                                        <td>{row.qty}</td>
                                                                        <td>{Number(row.rate).toFixed(2)}</td>
                                                                        <td>{Number(row.netTotal).toFixed(2)}</td>
                                                                    </tr>
                                                                ))
                                                            )}
                                                        </tbody>

                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* FOOTER BUTTONS */}
                        <div className="submit-footer">
                            <button
                                className="footer-btn cancel"
                                onClick={() => setOpenSubmitDialog(false)}
                                disabled={submitting}
                                style={{
                                    cursor: submitting ? "not-allowed" : "pointer",
                                    opacity: submitting ? 0.6 : 1
                                }}
                            >
                                Cancel
                            </button>

                            <button
                                className="footer-btn submit"
                                onClick={handleSubmitAPI}
                                disabled={submitting}
                                style={{
                                    cursor: submitting ? "not-allowed" : "pointer",
                                    opacity: submitting ? 0.6 : 1
                                }}
                            >
                                {submitting ? "Submitting..." : "Submit"}
                            </button>
                        </div>

                    </div>
                </div>
            )}

            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
            <ConfirmDialog
                open={openRevertPopup}
                title="Revert Combined Charge"
                message={`Are you sure you want to revert this combined charge?`}
                confirmText="Revert"
                cancelText="Cancel"
                onConfirm={confirmRevert}
                onCancel={cancelRevert}
            />
            <GenerateSeparatePopup
                isOpen={isGenerateSeparatePopupOpen}
                onClose={() => {
                    setIsGenerateSeparatePopupOpen(false);
                }}
                separateChargesData={separateChargesData}
                loading={isLoadingSeparateCharges}
                backdatedDays={backdatedDays}
                projectId={projectId}
            />
            <ConfirmDialog
                open={openSeparateConfirmDialog}
                title="Confirm Separate Invoice Action"
                message="There are charges that are not merged yet. Are you sure you want to proceed with separate invoice generation?"
                confirmText="Proceed to Generate"
                cancelText="Cancel"
                onConfirm={handleConfirmSeparateInvoice}
                onCancel={() => {
                    setOpenSeparateConfirmDialog(false);
                    setIsLoadingSeparateCharges(false);
                }}
            />
            <ConfirmDialog
                open={openConfirmDialog}
                title="Confirm Submit Action"
                message="There are charges that are not merged yet. Are you sure you want to proceed with submission?"
                confirmText="Proceed to Submit"
                cancelText="Cancel"
                onConfirm={handleConfirmSubmit}
                onCancel={() => setOpenConfirmDialog(false)}
            />
            {/* <ConfirmDialog
                open={openSaveDialog}
                title="Confirm Save"
                message="Are you sure to save the combine line item and merged charges?"
                confirmText={saving ? "Saving..." : "Save"}
                cancelText="Cancel"
                onConfirm={handleSaveAPI}
                onCancel={() => setOpenSaveDialog(false)}
                disableConfirm={saving}
            /> */}
        </>
    );
};

export default MergedCharges;